import { render } from "./ReportContentPopin.vue?vue&type=template&id=579c4c23&scoped=true"
import script from "./ReportContentPopin.vue?vue&type=script&lang=ts"
export * from "./ReportContentPopin.vue?vue&type=script&lang=ts"

import "./ReportContentPopin.vue?vue&type=style&index=0&id=579c4c23&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-579c4c23"

export default script